/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor, Badge, Card } from '@nexigendigital/nxui'
import { serviceAPI, useDeleteCancelRequestMutation } from 'api/service'

import CancelLightbox from 'containers/services/lightbox/cancelLightbox'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Cancel() {
    const location = useLocation()
    const id = +location.pathname?.split('/')[2]
    const { isLoading, isError, data } = serviceAPI.endpoints.pendingServiceCancellation.useQueryState(id)
    const [deleteCancelRequest] = useDeleteCancelRequestMutation()
    const [lightboxStatus, setLightboxStatus] = useState(false)
    const columns = useMemo(() => {
        if (Array.isArray(data) && data.length === 0) {
            return [
                {
                    Header: 'Cancel',
                    accessor: 'cancel'
                },
                {
                    Header: '',
                    accessor: 'action',
                    align: 'right'
                }
            ]
        }

        return [
            {
                Header: 'Cancel',
                accessor: 'cancel'
            },
            {
                Header: '',
                accessor: 'status'
            },
            {
                Header: '',
                accessor: 'action',
                align: 'right'
            }
        ]
    }, [data])
    const security = useMemo(() => {
        if (isLoading || isError) {
            return []
        }

        if (Array.isArray(data) && data.length === 0) {
            return [{
                cancel: 'Cancel Service',
                action: <Anchor color={'primary'} onClick={() => setLightboxStatus(true)}>Cancel</Anchor>
            }]
        }

        if (data?.completed) {
            return [{
                cancel: 'Cancel Service',
                status: <Badge color={'confirm'}>Completed</Badge>
            }]
        }

        return [{
            cancel: 'Cancel Service',
            status: <Badge color={'primary'}>IN PROGRESS</Badge>,
            action: <Anchor color={'primary'} onClick={() => deleteCancelRequest(id)}>Stop Cancellation</Anchor>
        }]
    }, [data, isLoading, isError])

    return (
        <>
            <CancelWrapper
                table={{
                    conditions: {
                        loading: isLoading && 'Checking existing cancellation request...',
                        sort: false
                    },
                    render: {
                        columns: () => columns,
                        data: () => security
                    }
                }}
            />
            <CancelLightbox
                id={id}
                status={lightboxStatus}
                close={() => setLightboxStatus(false)}
            />
        </>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const CancelWrapper = styled(Card)`
    width: 100%;
`
